export default __webpack_public_path__ + "static/LogoPaulPairet-3df467c0cb89f5277ebc357898345d0f.png";